import Quiz from './Quiz.container';

export default Quiz;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/quiz/index.js